/* eslint-disable @typescript-eslint/naming-convention */
import { INotification, INotificationResponse } from '../../IApiResponses';

const notificationsMapper = {
  response(notifications: INotificationResponse[]): INotification[] {
    return (notifications ?? []).map(item => {
      if (item.data) {
        const {
          key,
          severity,
          prod_rgn_name,
          data,
          data: {
            offer_code: offerRemoved,
          },
        } = item;

        return {
          data,
          key,
          offerRemoved,
          productRgnName: prod_rgn_name,
          severity: severity, 
        };
      }

      const {
        key,
        severity,
        prod_rgn_name,
      } = item;

      return {
        key,
        productRgnName: prod_rgn_name,
        severity: severity,
      };
    });
  },
};

export default notificationsMapper;